import { createQueryKeys } from "@lukemorales/query-key-factory";
import { queryOptions, useQuery } from "@tanstack/react-query";

import { api } from "@/lib/api";
import { type Paginate, type SearchRequest } from "@/types";

import { type ObjectiveType } from "../types";

export type ObjectiveTypeList = Paginate<ObjectiveType>;

// const include = "";

export const objectiveTypes = createQueryKeys("performance-objectives-types", {
  all: (page?: number, filter?: SearchRequest) => [{ page, filter }],
  one: (id?: number) => [id],
});

export const fetchObjectiveTypesQueryOptions = () =>
  queryOptions({
    ...objectiveTypes.all(),
    queryFn: () =>
      api
        .get<ObjectiveType[]>(`/performance/objectives/types`, {
          params: {},
        })
        .then((response) => response.data),
  });

export const useFetchObjectiveTypes = () =>
  useQuery(fetchObjectiveTypesQueryOptions());

export const fetchObjectiveTypeQueryOptions = (id?: number) =>
  queryOptions({
    ...objectiveTypes.one(id),
    queryFn: () =>
      api
        .get<ObjectiveType>(`/performance/objectives/types/${id}`)
        .then((response) => response.data),
  });

export const useFetchObjectiveType = (id?: number) =>
  useQuery(fetchObjectiveTypeQueryOptions(id));
